import { render } from "./alerts.vue?vue&type=template&id=5b3e0100&scoped=true"
import script from "./alerts.js?vue&type=script&lang=js"
export * from "./alerts.js?vue&type=script&lang=js"

import "./alerts.vue?vue&type=style&index=0&id=5b3e0100&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3e0100"]])

export default __exports__